import { LitElement, html } from 'lit';

/**
 * Linker submenu voor het instellingen-gebied. Twee kopjes (Bedrijf / Persoonlijk) met daaronder de losse instellingen-pagina's. Klik → `navigate`-event (path),
 * dat app-main opvangt. Light DOM zodat het de pagina-styling volgt.
 */
export class SettingsNav extends LitElement {
  static properties = { active: { type: String }, canCompany: { type: Boolean }, canTemplates: { type: Boolean }, canReport: { type: Boolean } };
  createRenderRoot() { return this; }

  _go(path) {
    this.dispatchEvent(new CustomEvent('navigate', { detail: { path }, bubbles: true, composed: true }));
  }

  get _groups() {
    // Recorder app (instructies en scangeluiden) en sjablonen horen bij het bedrijf: ze worden per bedrijf opgeslagen
    // en gelden voor iedereen in dat bedrijf.
    const company = [
      { label: 'Algemeen', path: '/settings/company', views: ['company-settings'] },
      { label: 'Recorder app', path: '/settings/recorder', views: ['recorder-settings'] },
    ];
    if (this.canTemplates) company.push({ label: 'Boringsjablonen', path: '/templates', views: ['templates', 'template-editor'] });
    // Rapportsjablonen en -teksten: alleen met de bètafunctie Rapportage.
    if (this.canReport) company.push({ label: 'Rapportagesjablonen', path: '/settings/report', views: ['report-settings'] });
    // Iedereen mag de texturen zien; aanpassen kan alleen een eigenaar, manager of sysadmin.
    company.push({ label: 'Texturen', path: '/settings/textures', views: ['texture-settings'] });
    return [
      // De bedrijfsinstellingen zijn alleen voor een bedrijfsbeheerder (eigenaar of manager);
      // een gewone gebruiker ziet alleen zijn eigen instellingen.
      ...(this.canCompany ? [{ header: 'Bedrijf', items: company }] : []),
      { header: 'Persoonlijk', items: [
        { label: 'Algemeen', path: '/personal/settings', views: ['personal-settings'] },
        // Opmaak apart van Algemeen: daar staat wie je bent en hoe je inlogt, hier wat alleen
        // jij ziet en zonder gevolgen aan en uit kan.
        { label: 'Opmaak', path: '/personal/appearance', views: ['personal-appearance'] },
      ] },
    ];
  }

  render() {
    return html`
      <nav style="width:220px; flex:0 0 220px; padding-right:8px;">
        ${this._groups.map((g) => html`
          <div style="margin-bottom:18px;">
            <div style="font-size:0.68rem; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; color:var(--mv-text-muted); padding:0 10px 6px;">${g.header}</div>
            ${g.items.map((it) => {
              const on = it.views.includes(this.active);
              return html`
                <a href=${it.path} @click=${(e) => { e.preventDefault(); this._go(it.path); }}
                   style="display:block; padding:8px 10px; border-radius:8px; font-size:0.9rem; font-weight:${on ? '700' : '500'}; text-decoration:none; cursor:pointer; color:${on ? 'var(--mv-primary)' : 'var(--mv-text)'}; background:${on ? 'var(--mv-primary-tint, rgba(46,158,91,0.1))' : 'transparent'};">
                  ${it.label}
                </a>`;
            })}
          </div>
        `)}
      </nav>
    `;
  }
}

customElements.define('settings-nav', SettingsNav);
